/**
 * Generated by orval v8.12.3 🍺
 * Do not edit manually.
 * TorqueTitan API
 * Auto repair shop management API
 * OpenAPI spec version: 1.0.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ApiError,
  GetRedirectTokenParams,
  PublicInspectionDetail,
  RedirectTokenResponse,
  ServiceRequestResponse,
} from './torqueTitanAPI.schemas';

import { apiFetcher } from '../apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getGetRedirectTokenUrl = (params: GetRedirectTokenParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/service-request/redirect-token?${stringifiedParams}`
    : `/service-request/redirect-token`;
};

/**
 * @summary Resolve a legacy public token (estimate/invoice/dvi/appointment) to the RO public token
 */
export const getRedirectToken = async (
  params: GetRedirectTokenParams,
  options?: RequestInit
): Promise<RedirectTokenResponse> => {
  return apiFetcher<RedirectTokenResponse>(getGetRedirectTokenUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getGetRedirectTokenQueryKey = (params?: GetRedirectTokenParams) => {
  return [`/service-request/redirect-token`, ...(params ? [params] : [])] as const;
};

export const getGetRedirectTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getRedirectToken>>,
  TError = ApiError,
>(
  params: GetRedirectTokenParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRedirectToken>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRedirectTokenQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRedirectToken>>> = ({ signal }) =>
    getRedirectToken(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRedirectToken>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRedirectTokenQueryResult = NonNullable<Awaited<ReturnType<typeof getRedirectToken>>>;
export type GetRedirectTokenQueryError = ApiError;

export function useGetRedirectToken<TData = Awaited<ReturnType<typeof getRedirectToken>>, TError = ApiError>(
  params: GetRedirectTokenParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRedirectToken>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRedirectToken>>,
          TError,
          Awaited<ReturnType<typeof getRedirectToken>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRedirectToken<TData = Awaited<ReturnType<typeof getRedirectToken>>, TError = ApiError>(
  params: GetRedirectTokenParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRedirectToken>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRedirectToken>>,
          TError,
          Awaited<ReturnType<typeof getRedirectToken>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRedirectToken<TData = Awaited<ReturnType<typeof getRedirectToken>>, TError = ApiError>(
  params: GetRedirectTokenParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRedirectToken>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Resolve a legacy public token (estimate/invoice/dvi/appointment) to the RO public token
 */

export function useGetRedirectToken<TData = Awaited<ReturnType<typeof getRedirectToken>>, TError = ApiError>(
  params: GetRedirectTokenParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRedirectToken>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetRedirectTokenQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetServiceRequestInspectionUrl = (token: string, shareToken: string) => {
  return `/service-request/${token}/inspection/${shareToken}`;
};

/**
 * @summary Get a DVI inspection rendered inside the unified service-request link
 */
export const getServiceRequestInspection = async (
  token: string,
  shareToken: string,
  options?: RequestInit
): Promise<PublicInspectionDetail> => {
  return apiFetcher<PublicInspectionDetail>(getGetServiceRequestInspectionUrl(token, shareToken), {
    ...options,
    method: 'GET',
  });
};

export const getGetServiceRequestInspectionQueryKey = (token: string, shareToken: string) => {
  return [`/service-request/${token}/inspection/${shareToken}`] as const;
};

export const getGetServiceRequestInspectionQueryOptions = <
  TData = Awaited<ReturnType<typeof getServiceRequestInspection>>,
  TError = ApiError,
>(
  token: string,
  shareToken: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceRequestInspection>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetServiceRequestInspectionQueryKey(token, shareToken);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceRequestInspection>>> = ({ signal }) =>
    getServiceRequestInspection(token, shareToken, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: token !== null && token !== undefined && shareToken !== null && shareToken !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getServiceRequestInspection>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetServiceRequestInspectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getServiceRequestInspection>>
>;
export type GetServiceRequestInspectionQueryError = ApiError;

export function useGetServiceRequestInspection<
  TData = Awaited<ReturnType<typeof getServiceRequestInspection>>,
  TError = ApiError,
>(
  token: string,
  shareToken: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceRequestInspection>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceRequestInspection>>,
          TError,
          Awaited<ReturnType<typeof getServiceRequestInspection>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetServiceRequestInspection<
  TData = Awaited<ReturnType<typeof getServiceRequestInspection>>,
  TError = ApiError,
>(
  token: string,
  shareToken: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceRequestInspection>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceRequestInspection>>,
          TError,
          Awaited<ReturnType<typeof getServiceRequestInspection>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetServiceRequestInspection<
  TData = Awaited<ReturnType<typeof getServiceRequestInspection>>,
  TError = ApiError,
>(
  token: string,
  shareToken: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceRequestInspection>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a DVI inspection rendered inside the unified service-request link
 */

export function useGetServiceRequestInspection<
  TData = Awaited<ReturnType<typeof getServiceRequestInspection>>,
  TError = ApiError,
>(
  token: string,
  shareToken: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceRequestInspection>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetServiceRequestInspectionQueryOptions(token, shareToken, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetServiceRequestUrl = (token: string) => {
  return `/service-request/${token}`;
};

/**
 * @summary Get unified customer service-request payload by public token
 */
export const getServiceRequest = async (token: string, options?: RequestInit): Promise<ServiceRequestResponse> => {
  return apiFetcher<ServiceRequestResponse>(getGetServiceRequestUrl(token), {
    ...options,
    method: 'GET',
  });
};

export const getGetServiceRequestQueryKey = (token: string) => {
  return [`/service-request/${token}`] as const;
};

export const getGetServiceRequestQueryOptions = <
  TData = Awaited<ReturnType<typeof getServiceRequest>>,
  TError = ApiError,
>(
  token: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceRequest>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetServiceRequestQueryKey(token);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceRequest>>> = ({ signal }) =>
    getServiceRequest(token, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getServiceRequest>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetServiceRequestQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceRequest>>>;
export type GetServiceRequestQueryError = ApiError;

export function useGetServiceRequest<TData = Awaited<ReturnType<typeof getServiceRequest>>, TError = ApiError>(
  token: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceRequest>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceRequest>>,
          TError,
          Awaited<ReturnType<typeof getServiceRequest>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetServiceRequest<TData = Awaited<ReturnType<typeof getServiceRequest>>, TError = ApiError>(
  token: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceRequest>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceRequest>>,
          TError,
          Awaited<ReturnType<typeof getServiceRequest>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetServiceRequest<TData = Awaited<ReturnType<typeof getServiceRequest>>, TError = ApiError>(
  token: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceRequest>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get unified customer service-request payload by public token
 */

export function useGetServiceRequest<TData = Awaited<ReturnType<typeof getServiceRequest>>, TError = ApiError>(
  token: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceRequest>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetServiceRequestQueryOptions(token, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}
